import React from 'react';
import { elementInfo } from '../data/assessmentData';
interface ResultsProps {
  id: string;
  scores: Record<string, number>;
  percentages: Record<string, number>;
  dominantElement: string;
}
const Results = ({
  id,
  scores,
  percentages,
  dominantElement
}: ResultsProps) => {
  // Sort elements by score
  const sortedElements = Object.keys(scores).sort((a, b) => scores[b] - scores[a]);
  const topElements = sortedElements.slice(0, 2);
  const secondaryElement = topElements[1];
  return <div id={id} className="mt-10 bg-white rounded-xl p-8 shadow-lg border border-gray-200" data-id="element-42">
      <h2 className="text-3xl font-bold text-center text-gray-800 mb-8" data-id="element-43">
        🌟 Your Five-Element Constitution Results
      </h2>
      <div className="space-y-4 mb-8" data-id="element-44">
        {sortedElements.map(element => {
        const isDominant = element === dominantElement;
        return <div key={element} className={`flex justify-between items-center p-5 rounded-lg border-2 transition-all ${isDominant ? 'border-green-500 bg-green-50 shadow-md' : 'border-gray-200'}`} data-id="element-45">
              <div className="flex items-center" data-id="element-46">
                <span className="text-3xl mr-4" data-id="element-47">
                  {elementInfo[element].icon}
                </span>
                <span className="text-xl font-semibold" data-id="element-48">
                  {elementInfo[element].name} Element
                  {isDominant && <span className="text-green-600 ml-3" data-id="element-49">⭐ Dominant</span>}
                </span>
              </div>
              <div data-id="element-50">
                <span className="text-3xl font-bold" data-id="element-51">{scores[element]}</span>
                <span className="text-lg text-gray-600 ml-2" data-id="element-52">
                  ({percentages[element]}%)
                </span>
              </div>
            </div>;
      })}
      </div>
      <div className="bg-gray-50 rounded-xl p-6 mt-8" data-id="element-53">
        <h3 className="text-xl font-bold text-gray-800 mb-4" data-id="element-54">
          🎯 Your Constitution Analysis
        </h3>
        <p className="font-semibold text-lg" data-id="element-55">
          Primary Element: {elementInfo[dominantElement].name}
        </p>
        <p className="mb-4 text-gray-700" data-id="element-56">
          {elementInfo[dominantElement].description}
        </p>
        {scores[secondaryElement] >= 3 && secondaryElement !== dominantElement && <>
              <p className="font-semibold text-lg" data-id="element-57">
                Secondary Element: {elementInfo[secondaryElement].name}
              </p>
              <p className="mb-4 text-gray-700" data-id="element-58">
                You also show significant {elementInfo[secondaryElement].name}{' '}
                characteristics: {elementInfo[secondaryElement].description}
              </p>
            </>}
        <p className="mt-4 font-semibold" data-id="element-59">Recommendations:</p>
        <p className="text-gray-700" data-id="element-60">
          This constitution assessment can guide your acupuncture treatment,
          lifestyle choices, and self-care practices. Consider discussing these
          results with a qualified TCM practitioner for personalized
          recommendations.
        </p>
      </div>
    </div>;
};
export default Results;